const getPropertyValue = (obj, property) => {
  if (Array.isArray(property)) {
    const foundProperty = property.find((prop) => obj[prop]);

    return foundProperty ? obj[foundProperty] : undefined;
  }

  return obj[property];
};

export const groupActivitiesByDate = (
  activities,
  dateProperty = "createdOn"
) => {
  const grouped = {};

  activities.forEach((activity) => {
    const date = new Date(getPropertyValue(activity, dateProperty));
    const dateKey = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    if (!grouped[dateKey]) {
      grouped[dateKey] = [];
    }
    grouped[dateKey].push(activity);
  });

  return grouped;
};

export const groupActivitiesForTimeline = (
  activities,
  dateProperty = "createdOn"
) => {
  const grouped = {};

  activities.forEach((activity) => {
    const date = new Date(getPropertyValue(activity, dateProperty));
    const timeKey = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    if (!grouped[timeKey]) {
      grouped[timeKey] = [];
    }

    grouped[timeKey].push(activity);
  });

  return grouped;
};
